<template>
  <div class="d-flex align-center justify-center">
    <v-btn icon small @click="dialog = true">
      <v-icon>mdi-pencil-outline</v-icon>
    </v-btn>

    <div class="text-nowrap overflow-hidden ml-2" style="max-width: 100px; text-overflow: ellipsis"
         v-html="data.followup_text"></div>

    <custom-popup v-model="dialog" :cons="{title: 'تغییر وضعیت'}" hide-confirm max-width="450">
      <v-card flat>
        <v-card-text>
          <v-textarea v-model="data.followup_text" class="rounded-lg" clear-icon="mdi-close-circle-outline" clearable
                      dense hide-details label="متن" outlined/>
        </v-card-text>
        <v-card-actions class="justify-end px-4" @click="sendText">
          <v-btn :loading="loading" class="btn-accept rounded-lg ma-0" depressed>ذخیره</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "editReportStatus",

  props: {
    data: Object
  },

  data: () => ({
    dialog: false,
    loading: false
  }),

  methods: {
    sendText() {
      this.loading = true;

      this.requestApiPost(`task/smsReports/followups/${this.data.id}`, {
        text: this.data.followup_text
      })
        .then(({data}) => {
          this.$toast.success('با موفقیت ذخیره شد.');
          this.dialog = false
        })
        .catch(({response}) => console.log('failed to save text: ', response))
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>